var _rect, _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.7963,
    height: 11.9259,
    rx: 2.55556,
    transform: "matrix(-1 0 0 1 9.79634 7.42603)",
    fill: "#7A67FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M2.98157 3.20375C2.98157 1.79236 4.12573 0.648193 5.53712 0.648193H16.6112C18.0226 0.648193 19.1668 1.79235 19.1668 3.20375V16.7963C19.1668 18.2077 18.0226 19.3519 16.6112 19.3519H5.53712C4.12573 19.3519 2.98157 18.2077 2.98157 16.7963V3.20375Z",
    fill: "url(#paint0_linear_3463_4812)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3463_4812)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54825 19.3519H5.53712C4.12573 19.3519 2.98157 18.2078 2.98157 16.7964V7.42603H5.5371C6.94849 7.42603 8.09265 8.57018 8.09265 9.98158V16.7964C8.09265 18.2041 6.95452 19.3459 5.54825 19.3519Z",
    fill: "#7B55DF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24081 4.46289C6.77035 4.46289 6.38896 4.84428 6.38896 5.31474C6.38896 5.78521 6.77035 6.16659 7.24081 6.16659H10.2223C10.6928 6.16659 11.0741 5.78521 11.0741 5.31474C11.0741 4.84428 10.6928 4.46289 10.2223 4.46289H7.24081ZM7.24085 13.4073C6.77039 13.4073 6.389 13.7887 6.389 14.2592C6.389 14.7296 6.77039 15.111 7.24085 15.111H11.0742C11.5447 15.111 11.926 14.7296 11.926 14.2592C11.926 13.7887 11.5447 13.4073 11.0742 13.4073H7.24085ZM12.778 14.2592C12.778 13.7887 13.1593 13.4073 13.6298 13.4073H14.9076C15.3781 13.4073 15.7594 13.7887 15.7594 14.2592C15.7594 14.7296 15.3781 15.111 14.9076 15.111H13.6298C13.1593 15.111 12.778 14.7296 12.778 14.2592ZM7.24085 7.87031C6.77039 7.87031 6.389 8.2517 6.389 8.72216V10.8518C6.389 11.3223 6.77039 11.7036 7.24085 11.7036H14.9075C15.378 11.7036 15.7594 11.3223 15.7594 10.8518V8.72216C15.7594 8.2517 15.378 7.87031 14.9075 7.87031H7.24085Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3463_4812",
    x: 0.851938,
    y: 5.2964,
    width: 9.37034,
    height: 16.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06481,
    result: "effect1_foregroundBlur_3463_4812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3463_4812",
    x1: 2.98157,
    y1: 10,
    x2: 19.1668,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon4);
export default __webpack_public_path__ + "static/media/navicon4.548f8baa1ae163e63cf055ce7e1bea10.svg";
export { ForwardRef as ReactComponent };